<svelte:options
	customElement={{
		tag: "favorite-toggle",
		shadow: "none",
	}}
/>

<script lang="ts">
	import { onMount } from "svelte";

	import SvgIcon from "../components/svg-icon.svelte";
	import { store } from "./store";
	import type { GalleryImage } from "@/models";
	import { loadFromJsonScriptElement } from "@/utils";
	import { initFluentContext, localize } from "@/localization";
	import { trackEvent } from "@/analytics";

	interface Props {
		item?: GalleryImage | null;
		itemselector?: string | null;
	}

	let { item = null, itemselector = null }: Props = $props();

	initFluentContext();

	// svelte-ignore state_referenced_locally -- the prop only seeds the local value; itemselector fills it in onMount
	let resolvedItem: GalleryImage | null = $state(item);
	let justActivated = $state(false);
	let isSelected = $derived(resolvedItem != null && store.has(resolvedItem.id));
	let tooltip = $derived(isSelected ? localize("favorite-remove") : localize("favorite-add"));

	onMount(() => {
		if (resolvedItem == null && itemselector != null) {
			resolvedItem = loadFromJsonScriptElement<GalleryImage>(itemselector);
		}
	});

	function toggle() {
		if (resolvedItem == null) {
			return;
		}

		if (store.has(resolvedItem.id)) {
			store.delete(resolvedItem.id);
			justActivated = false;
		} else {
			store.add(resolvedItem);
			justActivated = true;
			trackEvent("favorite_add", { id: resolvedItem.id });
		}
	}
</script>

<button class="button is-ghost is-rounded favorite-toggle" class:is-dark={!isSelected} class:is-primary={isSelected} class:is-pop={justActivated} onclick={toggle} onanimationend={() => justActivated = false}>
	<SvgIcon icon="love-it" {tooltip} />
</button>
